import { Box } from '@tanium/react-box';
import { CopyClipboardIcon } from '@tanium/react-graphics';
import { IconButton } from '@tanium/react-icon-button';
import { Stack } from '@tanium/react-stack';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface CopyableTextProps extends JSX.IntrinsicAttributes {
  text: string;
  bold?: boolean;
}

export const CopyableText: React.VFC<CopyableTextProps> = ({ text, bold }) => {
  const { t } = useTranslation();
  const onClick = useCallback(async () => {
    await navigator.clipboard?.writeText(text);
  }, [text]);

  return (
    <Stack direction="row" alignItems="center" itemSpacing={1}>
      {bold ? <strong>{text}</strong> : text}
      <Box mt={'-4px'}>
        <IconButton
          onClick={onClick}
          width={16}
          height={16}
          icon={CopyClipboardIcon}
          label={t('Copy text to clipboard', { text })}
        ></IconButton>
      </Box>
    </Stack>
  );
};
